import ContentCard from 'components/cards/content-card';
import styles from './article-card.module.scss';
import { formatFullName } from 'lib/person/formatFullName';
import { commaize } from 'helpers/helpers';
import AudioIcon from 'assets/icons/audio.svg';
import CloseLookIcon from 'assets/icons/close-look.svg';
import VideoIcon from 'assets/icons/video.svg';
import { type ReactElement } from 'react';
import { type SanityPerson } from '@metmuseum/types';
import type { ContentCardProps } from 'components/cards/content-card';
import { formatMetDate } from 'helpers/date-time';
import { type Image } from '@metmuseum/types';
import type {
	SanityArticle,
	ElasticPerson,
	ArticleCardData,
} from '@metmuseum/types';

export const returnBadge = (type: string): Badge => {
	switch (type) {
		case 'closeLook':
			return {
				text: 'Close Look',
				icon: <CloseLookIcon height="1.5em" width="1.5em" />,
				color: 'var(--color-text-header)',
			};
		case 'audio':
			return {
				text: 'Audio',
				icon: <AudioIcon height="1.5em" width="1.5em" />,
				color: 'var(--color-text-header)',
			};
		case 'video':
			return {
				text: 'Video',
				icon: <VideoIcon height="1.5em" width="1.5em" />,
				color: 'var(--color-text-header)',
			};
		default:
			return null;
	}
};

const ArticleCard = ({
	contentType,
	series,
	link,
	date,
	comingSoon,
	contributors,
	type,
	sideBySide,
	className,
	...restProps
}: Props) => {
	const badge = returnBadge(type || contentType);
	const badgeArray = badge ? [badge] : [];
	comingSoon &&
		badgeArray.push({ text: 'coming soon', color: 'var(--color-blue-bright)' });

	const classNames = [];
	if (comingSoon) classNames.push(styles.comingSoon);
	if (className) classNames.push(className);

	return (
		<ContentCard
			{...restProps}
			sideBySide={sideBySide}
			className={classNames.join(' ')}
			eyebrow={series}
			link={comingSoon ? null : link}
			badges={badgeArray}
		>
			{contributors && (
				<div className={styles.attribution}>
					{commaize(
						contributors?.map((contributor) =>
							formatFullName(contributor.person),
						),
					)}
				</div>
			)}
			{date && <div className={styles.attribution}>{formatMetDate(date)}</div>}
		</ContentCard>
	);
};

interface Badge {
	text: string;
	icon?: ReactElement;
	color?: string;
}

interface Props extends ContentCardProps {
	contentType: ArticleCardData['_type'];
	author?: string;
	comingSoon?: boolean;
	contributors?: Array<{
		person: SanityPerson | (ElasticPerson & { title: string });
	}>;
	image: Image;
	date?: string;
	link?: string;
	series?: string;
	subTitle?: string;
	type?: SanityArticle['type'];
}

export default ArticleCard;
export type { Props as ArticleCardProps };
